module.exports = __webpack_public_path__ + "static/media/cheveron-right.75a1953c.svg";